import React, { useContext } from 'react'
import ProviderPreferenceForm from './ProviderPreferenceForm'
import CareManagerPreferenceForm from './CareManagerPreferenceForm'
import UserContext, { Roles } from '../../UserContext'

const Preferences: React.FC = () => {
    const { hasAnyRole } = useContext(UserContext)

    if (hasAnyRole(Roles.Provider)) {
        return <ProviderPreferenceForm />
    }

    if (hasAnyRole(Roles.WaiverServiceCoordinator, Roles.WaiverServiceLeader, Roles.MarketAdmin)) {
        return <CareManagerPreferenceForm />
    }

    return <p>You do not have access to user preferences.</p>
}

export default Preferences